import { useState, useEffect } from 'react';
import { SyntheticEvent } from 'react-draft-wysiwyg';

const useInlineEditing = ({
  labelText,
  onChange,
}: {
  labelText: string;
  onChange: (text: string) => void;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(labelText);

  useEffect(() => {
    setText(labelText);
  }, [labelText]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleOnSubmit();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  const handleOnSubmit = () => {
    if (text === labelText) {
      setIsEditing(false);

      return;
    }

    onChange(text);
    setIsEditing(false);
  };

  const handleOnFocus = (e: SyntheticEvent) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  return {
    isEditing,
    text,
    setText,
    handleOnFocus,
    handleKeyDown,
    handleOnSubmit,
  };
};

export default useInlineEditing;
